// aiApp/components/Bots/Facebook/apiService.js
import axios from "axios";
import { getAuth } from "firebase/auth";

const API_BASE_URL = "/.netlify/functions";

async function getIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error("Użytkownik nie jest zalogowany");
  return user.getIdToken(/* forceRefresh= */ true);
}

export const fetchSuggestions = async (category) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-facebook-suggestions`,
      { category },
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching facebook suggestions:", error.message);
    throw new Error(
      "Wystąpił błąd podczas generowania odpowiedzi. Spróbuj ponownie później."
    );
  }
};
export const fetchSuggestionDetails = async (title, description) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-facebook-post`,
      { title, description },
      { 
        headers: { Authorization: `Bearer ${idToken}` },
        timeout: 10000 // Dodano timeout, aby uniknąć zawieszeń
      }
    );
    if (!response.data || !response.data.content) {
      throw new Error("Brak danych w odpowiedzi serwera.");
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching facebook post:", error.message, error.response?.status);
    throw new Error(
      "Wystąpił błąd podczas generowania postu. Spróbuj ponownie później."
    );
  }
};